import { Pipe, PipeTransform } from '@angular/core';
import { BatchJobState } from '../../viewmodels/batch/batch-job';

@Pipe({
  name: 'batchJobState',
})
export class BatchJobStatePipe implements PipeTransform {
  transform(value: BatchJobState): string {
    switch (value) {
    case BatchJobState.None:
      return 'None';
    case BatchJobState.Queued:
      return 'Queued';
    case BatchJobState.Processing:
      return 'Processing';
    case BatchJobState.Complete:
      return 'Completed';
    case BatchJobState.Failed:
      return 'Failed';
    default:
      return 'Unknown';
    }
  }
}
